import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// import 'libs/IntercomLoader.js';
import './Sentry';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from './redux/store';
import 'api/fetchInterceptor';
import * as serviceWorker from './serviceWorker';

// <React.StrictMode> was disabled due to https://github.com/ant-design/ant-design/issues/22493

const render = () => {
  const App = require('./App').default;

  ReactDOM.render(
    // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>,
    // </React.StrictMode>
    document.getElementById('root'),
  );
};

render();

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', render);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
